import { useRef, useState } from "react";
import { createPortal } from "react-dom";
import { ConfirmationModal } from "./ConfirmationModal";

function LogoutIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M10 4H5.8A1.8 1.8 0 0 0 4 5.8v12.4A1.8 1.8 0 0 0 5.8 20H10M14.5 8.5 18 12l-3.5 3.5M18 12H9" />
    </svg>
  );
}

export function LogoutButton({ onLogout, withLabel = false, onOpen }: { onLogout: () => void; withLabel?: boolean; onOpen?: () => void }) {
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const button = useRef<HTMLButtonElement>(null);

  function closeConfirmation() {
    setConfirmationOpen(false);
    if (withLabel) button.current?.closest("details")?.querySelector("summary")?.focus();
  }

  const confirmation = confirmationOpen && <ConfirmationModal
    title="Wirklich abmelden?"
    message="Willst du dich wirklich ausloggen?"
    onCancel={closeConfirmation}
    onConfirm={() => {
      closeConfirmation();
      onLogout();
    }}
  />;

  return (
    <>
      <button ref={button} className={`logout-button${withLabel ? " header-menu-item" : ""}`} aria-label="Abmelden" title="Abmelden" onClick={() => { setConfirmationOpen(true); onOpen?.(); }}>
        <LogoutIcon />
        {withLabel && <span>Abmelden</span>}
      </button>
      {withLabel ? confirmation && createPortal(confirmation, document.body) : confirmation}
    </>
  );
}

